import type { ReactElement } from 'react'

import Content from '../../templateComponents/Workspace/Workspace'

type Props = {
  page: Core.Page
}

export default function Page({ page }: Readonly<Props>): ReactElement {
  return (
    <div className="template-page">
      <h1>{page.title}</h1>
      <Content />
    </div>
  )
}
